<template>
  <base-modal class="screen-time-management-modal"
              :show="show"
              @close="close">
    <div slot="header">
      {{ $t("screentimeManagement.title") }}
    </div>

    <screen-time-management :childId="child.id"
                            :from-device-availability-modal="fromBus.fromDeviceAvailabilityModal"
                            :show="show" />
  </base-modal>
</template>

<script>
  import ScreenTimeManagement from '@/components/Child/ChildScreenTime/ScreenTimeManagement'
  import modalMixin from '@/mixins/modalMixin.js'

  import analytics from '@/services/analytics.js'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      ScreenTimeManagement
    },

    created() {
      analytics.sendEvent('ScrTimeManage_Sc')
    },

    data() {
      return {
        fromBus: {
          child: null,
          fromDeviceAvailabilityModal: false
        }
      }
    },

    computed: {
      child() {
        return this.fromBus.child ? this.getChildById(this.fromBus.child.id) : {}
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      })
    },

    beforeMount() {
      this.setOpenListener('screentime')
    }
  }
</script>
